import { useState } from 'react'

import Box from '@mui/material/Box/Box'
import Tab from '@mui/material/Tab/Tab'
import Tabs from '@mui/material/Tabs/Tabs'

import { VerticalTabPanel } from 'components/common/VerticalTabPanel'

import BookingSchedulerControls from './BookingSchedulerControls'
import CallHistoryTab from './CallHistoryTab'

function commonProps(index: TabId) {
  return {
    id: `schedulers-attempts-tab-${index}`,
    'aria-controls': `schedulers-attempts-tabpanel-${index}`,
  }
}

enum TabId {
  SchedulersControls = 0,
  CallHistory,
}

interface BookingSchedulerAttemptsProps {
  bookingId: string | null
}

const BookingSchedulerAttempts = ({ bookingId }: BookingSchedulerAttemptsProps) => {
  const [tabValue, setTabValue] = useState(0)

  const tabs = {
    schedulerControls: { id: TabId.SchedulersControls, label: 'Scheduler Controls' },
    callHistory: { id: TabId.CallHistory, label: 'Call History' },
  }

  const handleChange = (_, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        backgroundColor: (theme) => theme.palette.background.paper,
      }}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        orientation='vertical'
        aria-label='schedulers attempts tabs'
        variant='scrollable'
        sx={{
          boxShadow: (theme) => `inset -2px 0 0 0 ${theme.palette.divider}`,
          minWidth: (theme) => theme.spacing(22),
        }}>
        <Tab
          label={tabs.schedulerControls.label}
          key={tabs.schedulerControls.id}
          {...commonProps(tabs.schedulerControls.id)}
        />
        <Tab
          label={tabs.callHistory.label}
          key={tabs.callHistory.id}
          {...commonProps(tabs.callHistory.id)}
        />
      </Tabs>

      <VerticalTabPanel
        value={tabValue}
        index={tabs.schedulerControls.id}
        key={tabs.schedulerControls.id}
        px={2}
        width={(theme) => {
          return `calc(100% - ${theme.spacing(19)})`
        }}>
        <BookingSchedulerControls bookingId={bookingId} />
      </VerticalTabPanel>

      <VerticalTabPanel
        value={tabValue}
        index={tabs.callHistory.id}
        key={tabs.callHistory.id}
        px={2}
        width={(theme) => {
          return `calc(100% - ${theme.spacing(19)})`
        }}>
        <CallHistoryTab />
      </VerticalTabPanel>
    </Box>
  )
}

export default BookingSchedulerAttempts